import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import Container from '../../components/Container';
import { Grid, ListItem, Box, Divider } from '@material-ui/core'
import CustomTypo from '../../components/CustomTypo'
import { BackOnPrimaryIcon, DownIcon, UpIcon } from '../../components/icons'
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress'
import InfiniteScroll from 'react-infinite-scroll-component';
import ButtonCustom from '../../components/ButtonCustom';
import { formatDateToDDMMYYYYFrEpoch, formatDateToDDMMYYYYHHSSFrEpoch } from '../../utils/util';
import { domainName, portal_config } from '../../../portal.config';
const styles = theme => ({
    container: {
        padding: theme.spacing(6),
    },
    item: {
        marginTop: theme.spacing(4),
        padding: theme.spacing(4),
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(2),
    },
    boxItemContent: {
        padding: theme.spacing(3, 4, 3, 4),
        marginTop: theme.spacing(2),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        cursor: 'pointer',
    },
    box: {
        padding: theme.spacing(2, 2, 0, 0)
    },
    box_first: {
        paddingTop: theme.spacing(2)
    },
    box_second: {
        paddingTop: theme.spacing(1)
    }
});
function AllotmentDetailView(props) {
    const { classes, t, wallet_info, currency, onCloseAllotment, showLoading, handleLoadMore, hasMore, showLoadMore } = props;
    //console.log("wallet_info:", this.props.wallet_info);
    const allotments = Array.from(wallet_info)
    return (
        <DrawerCustom
            open={props.open}
            onClose={onCloseAllotment}
            title={t('allotment_title')}
            children={
                <Grid item>
                    <Grid item container spacing={2} justifyContent='center'>
                        <ButtonCustom size='sm' color={props.tab == 0 ? 'primary' : 'secondary'} onClick={() => props.setTab(0)}>{t('Spend Conditions')}</ButtonCustom>
                        <ButtonCustom size='sm' color={props.tab == 1 ? 'primary' : 'secondary'} onClick={() => props.setTab(1)}>{t('Wallet Analysis')}</ButtonCustom>
                    </Grid>
                    {props.tab == 0 && <>
                        <Grid xs={12} item style={{ marginTop: 10 }}>
                            <CustomTypo variant='body1' color='onPrimary' >{t('allotment_desc')}</CustomTypo>
                        </Grid>
                        {showLoading ? <Grid xs={12} item container justify='center'><CustomizedCircularProgress color="primary" /></Grid> : null}
                        <Grid xs={12} item>
                            <InfiniteScroll
                                dataLength={allotments.length} //This is important field to render the next data
                                next={handleLoadMore}
                                hasMore={hasMore}
                                loader={showLoadMore ? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                            >
                                <Grid xs={12} item container className={classes.margin}>
                                    {allotments.map((item, index) => item.amount && item.amount > 0 ?
                                        <AllotmentItem key={index} item={item} classes={classes} currency={currency} /> : null
                                    )}
                                </Grid>
                            </InfiniteScroll>
                        </Grid>
                    </>}
                    {props.tab == 1 && <>
                        {showLoading ? <Grid xs={12} item container justify='center'><CustomizedCircularProgress color="primary" /></Grid> : null}
                        <WalletJournalsView
                            transactions={props.transactions}
                            {...props}
                            hasMore={props.hasMoreWalletTransactions}
                            handleLoadMore={props.handleLoadMoreWalletTransactions}
                            showLoadMore={props.showLoadMoreWalletTransactions}
                        />
                    </>}
                </Grid>} />
    );
}
function AllotmentItem(props) {
    const { item, currency } = props;
    const { classes, t } = props;
    return (
        <Grid xs={12} item container className={classes.item}>
            <Grid item container xs={12} >
                <CustomTypo variant='h3'>{currency}{item.amount ? item.amount : "0.00"}</CustomTypo>
            </Grid>
            <Grid item container xs={12} >
                <CustomTypo mg_top_md >{item.conditionText}</CustomTypo>
            </Grid>
        </Grid>
    )
}
function WalletJournalsView(props) {
    const { classes, t, transactions, currency, handleLoadMore, showLoadMore, hasMore, showLoading } = props;
    return (
        <>
            {transactions && <Grid xs={12} item style={{ marginTop: 10 }}>
                <InfiniteScroll
                    dataLength={transactions.length} //This is important field to render the next data
                    next={handleLoadMore}
                    hasMore={hasMore}
                    loader={showLoadMore ? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                    height={window.innerHeight}
                >
                    <Grid xs={12} item>
                        {transactions.map((item, index) => <WalletJournalItem classes={classes} key={index} t={t}
                            item={item} currency={currency}
                            onClickDetail={props.onClickDetail}
                            transactionDetail={props.transactionDetail}
                            showDetail={props.showDetail} />
                        )}
                    </Grid>
                </InfiniteScroll>
            </Grid>}
        </>
    )
}

function WalletJournalItem(props) {
    const { item, classes, currency, t } = props
    var showDetail = props.showDetail && props.transactionDetail && props.transactionDetail.id && props.transactionDetail.id === item.id;
    var reward_event = item && item.reward_event ? item.reward_event : null;
    var financial_event = item && item.financial_event ? item.financial_event : null;
    var wallet_fee = item && item.wallet_fee ? item.wallet_fee : null;
    var order = item && item.order ? item.order : null;
    let currency_symbol = currency;
    const getType = () => {
        if (reward_event && reward_event.type) {
            return (
                <CustomTypo mg_top_sm mg_left_xl size="xs" color={item.type != "CREDIT" ? 'error' : 'success'} variant='subtitle2'>
                    {mappingCode(reward_event.type, t)}
                </CustomTypo>
            )
        }
        else if (financial_event && financial_event.type) {
            return (
                <CustomTypo mg_top_sm mg_left_xl size="xs" color={item.type === 'CREDIT' ? 'success' : 'danger'} variant='subtitle2'>
                    {mappingCode(financial_event.type, t)}
                </CustomTypo>
            )
        }
        else if (wallet_fee && wallet_fee.type) {
            return (
                <CustomTypo mg_top_sm mg_left_xl size="xs" style={{ color: portal_config[domainName].customColorWalletFee ? portal_config[domainName].customColorWalletFee : undefined }} variant='subtitle2'>
                    {/* {wallet_fee.type} */}
                    {mappingCode('Wallet_Fee', t)}
                </CustomTypo>
            )
        }
        else if (order) {
            if (order && order.number)
                return (
                    <CustomTypo mg_top_sm mg_left_xl size="xs" color={'error'} variant='subtitle2'>
                        {t('order_type_title')}
                    </CustomTypo>
                );
            else return (
                <CustomTypo mg_top_sm mg_left_xl size="xs" color={'error'} variant='subtitle2'>
                    {t('spend_type_title')}
                </CustomTypo>
            );
        }
        // else{
        //     return(
        //         <CustomTypo mg_top_sm mg_left_xl size="xs" color={'success'} variant='subtitle2'>
        //         {t('pass_redeemed')}
        //     </CustomTypo>
        //     )
        // }
    }
    return (
        <div>
            <Grid xs={12} item container className={classes.boxItemContent} onClick={() => props.onClickDetail(item)} data-wallet-journal-id={item.id}>
                <Grid xs={12} item container direction='row' alignItems='center'>
                    <Grid item xs={9}>
                        <Grid item xs={12} container direction='row' alignItems='center'>
                            <CustomTypo mg_top_sm variant='body2' color='secondary'>
                                {item.posted_on ? formatDateToDDMMYYYYHHSSFrEpoch(item.posted_on, false) : ""}
                            </CustomTypo>
                            <CustomTypo mg_top_sm mg_left_sm variant='subtitle2' color={item.type === 'CREDIT' ? 'success' : 'error'}>
                                {currency_symbol}{item.amount ? item.amount.toFixed(2) : "0.00"}
                            </CustomTypo>
                            {getType()}
                        </Grid>
                    </Grid>
                    <Grid item xs={3} container justify='flex-end'>
                        {/* <ButtonCustom  size="xs" color={item.type === 'CREDIT' ? 'green' : 'danger'}>
                        {item.type}
                    </ButtonCustom> */}
                        {showDetail ? <UpIcon /> : <DownIcon />}
                    </Grid>
                </Grid>

                {/* <Grid xs={12} item container alignItems='center'>
                <Grid item xs={2} xl={1}>
                    <CustomTypo mg_top_sm variant='subtitle2' color='secondary'>
                        {currency}{item.amount ? item.amount.toFixed(2) : "0.00"}
                    </CustomTypo> 
                </Grid>
                <Grid item xs={10} xl ={11}>
                    {getType()}
                </Grid>
                    
            </Grid> */}

                {showDetail && reward_event && <Grid item xs={12} className={classes.box}>
                    <Divider />
                    {reward_event.state && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        {/* <Grid item xs={6}>
                        <CustomTypo variant='body1'>{t('reward_event_state')}</CustomTypo>
                    </Grid> */}
                        <Grid item xs={6}>
                            <CustomTypo size="xs" mg_top_sm color={reward_event.state != 'POSTED' ? 'error' : 'success'} variant='body2'>
                                {reward_event.state}
                            </CustomTypo>
                        </Grid>
                    </Grid>}
                    {/* <Grid item xs={12} container direction='row' className={classes.box_first}>
                    <Grid item xs={6}>
                        <CustomTypo variant='subtitle2'>{ t('reward_event')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo size="xs" color={item.type != "CREDIT" ? 'error' : 'success'} variant='subtitle2'>
                            {mappingCode(reward_event.type, t)}
                        </CustomTypo>
                    </Grid>
                </Grid> */}
                    {reward_event.date && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <CustomTypo variant='body1'>{t('reward_event_date')}: </CustomTypo>
                        <CustomTypo variant='body1' mg_left_sm>{reward_event.date ? formatDateToDDMMYYYYFrEpoch(reward_event.date) : ""}</CustomTypo>
                    </Grid>}
                    {reward_event.amount > 0 && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <CustomTypo variant='body1'>{t('reward_event_amout')}: </CustomTypo>
                        <CustomTypo variant='body1' mg_left_sm>{currency_symbol}{reward_event.amount ? reward_event.amount.toFixed(2) : '0.00'}</CustomTypo>
                    </Grid>}
                    {reward_event.spend_method && <Grid item xs={12} container direction='row' alignItems="center" className={classes.box_second}>
                        <CustomTypo variant='body1'>{t('reward_event_spend_method')}: </CustomTypo>
                        <CustomTypo variant='body1' mg_left_sm>{mappingCode(reward_event.spend_method, t)}</CustomTypo>
                    </Grid>}
                    {reward_event.reward_offer && reward_event.reward_offer.name && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <CustomTypo variant='body1'>{t('reward_event_offer_name')}: </CustomTypo>
                        <CustomTypo variant='body1' mg_left_sm>{reward_event.reward_offer.name}</CustomTypo>
                    </Grid>}
                </Grid>}

                {showDetail && financial_event && <Grid item xs={12} className={classes.box}>
                    <Divider />
                    {financial_event.life_cycle_state && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        {/* <Grid item xs={6}>
                        <CustomTypo variant='body1'>{t('financial_event_life_cycle_state')}</CustomTypo>
                    </Grid> */}
                        <Grid item xs={6} container>
                            <CustomTypo size="xs" mg_top_sm color={financial_event.life_cycle_state === 'POSTED' ? 'success' : 'error'} variant='body2'>
                                {financial_event.life_cycle_state}
                            </CustomTypo>
                        </Grid>
                    </Grid>}
                    {/* <Grid item xs={12} container direction='row' className={classes.box_first}>
                    <Grid item xs={6}>
                        <CustomTypo variant='subtitle2'>{ t('financial_event')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo size="xs" color={financial_event.type === 'TOP_UP' ? 'success' : 'danger'} variant='subtitle2'>
                            {mappingCode(financial_event.type, t)}
                        </CustomTypo>
                    </Grid>
                </Grid> */}
                    {financial_event.reference_number && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <CustomTypo variant='body1'>{t('financial_event_number')}</CustomTypo>
                        <CustomTypo variant='body1' mg_left_sm>{financial_event.reference_number}</CustomTypo>
                    </Grid>}
                    {financial_event.date && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <CustomTypo variant='body1'>{t('financial_event_date')}</CustomTypo>
                        <CustomTypo variant='body1' mg_left_sm>{financial_event.date ? formatDateToDDMMYYYYFrEpoch(financial_event.date) : ""}</CustomTypo>
                    </Grid>}
                    {financial_event.amount > 0 && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <CustomTypo variant='body1'>{t('financial_event_amount')}</CustomTypo>
                        <CustomTypo variant='body1' mg_left_sm>{currency_symbol}{financial_event.amount ? financial_event.amount.toFixed(2) : '0.00'}</CustomTypo>
                    </Grid>}
                </Grid>}

                {showDetail && wallet_fee && <Grid item xs={12} className={classes.box}>
                    <Divider />
                    <Grid item xs={12} container direction='row' className={classes.box_first}>
                        <CustomTypo variant='subtitle2'>{t('wallet_fee')}: </CustomTypo>
                        <CustomTypo variant='subtitle2' size="xs" color={wallet_fee.type === 'CREDIT' ? 'success' : 'danger'} mg_left_sm>
                            {wallet_fee.type}
                        </CustomTypo>
                    </Grid>
                    {wallet_fee.name && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <CustomTypo variant='body1'>{t('wallet_fee_name')}: </CustomTypo>
                        <CustomTypo variant='body1' mg_left_sm>{wallet_fee.name}</CustomTypo>
                    </Grid>}
                </Grid>}

                {showDetail && order && <Grid item xs={12} className={classes.box}  >
                    <Divider />
                    {/* <Grid item xs={12} container direction='row' className={classes.box_first}>
                    <Grid item xs={6}>
                        <CustomTypo variant='subtitle2'>{ t('journal_order')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                    </Grid>
                </Grid> */}
                    {order.number && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <CustomTypo variant='body1'>{t('journal_order_number')}: </CustomTypo>
                        <CustomTypo variant='body1' mg_left_sm>{order.number}</CustomTypo>
                    </Grid>}
                    {/* {order.submitted_on && <Grid item xs={12} container direction='row'  className={classes.box_second}>
                    <Grid item xs={6}>
                        <CustomTypo variant='body1'>{t('journal_order_submitted_on')}</CustomTypo>
                    </Grid>
                    <Grid item xs={6} container justify='flex-end'>
                        <CustomTypo variant='body1'>{order.submitted_on ? formatDateToDDMMYYYYFrEpoch(order.submitted_on) : ""}</CustomTypo>
                    </Grid>
                </Grid>} */}
                    {order.fulfilled_by && order.fulfilled_by.name && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <CustomTypo variant='body1'>{t('journal_order_fulfilled_by')}: </CustomTypo>
                        <CustomTypo variant='body1' mg_left_sm>{order.fulfilled_by.name}</CustomTypo>
                    </Grid>}
                    {order.total_cost && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <CustomTypo variant='body1'>{t('journal_order_total_cost')}: </CustomTypo>
                        <CustomTypo variant='body1' mg_left_sm>{currency_symbol}{order.total_cost ? order.total_cost.toFixed(2) : '0.00'}</CustomTypo>
                    </Grid>}
                </Grid>}
            </Grid>

        </div>
    )
}

function mappingCode(state, t) {
    if (state == "TOP_UP") {
        return t('financial_event_top_up');
    } else if (state == 'TRANSFER') {
        return t('financial_event_transfer');
    } else if (state == 'INSTANT') {
        return t('spend_method_instant');
    } else if (state == 'AUTOMATIC_SPEND' || state == 'AUTO_SPEND') {
        return t('spend_method_automatic');
    } else if (state == 'ON_REQUEST') {
        return t('spend_method_on_request');
    } else if (state == 'Wallet_Fee') {
        return t('wallet_fee')
    } else if (state == 'AWARD') {
        return t('award_type_title');
    } else if (state == 'SPEND') {
        return t('spend_type_title');
    } else if (state == 'PASS_REDEMPTION') {
        return t('financial_event_pass')
    } else if (state == 'PURCHASE_CANCELLATION') {
        return t('purchase_cancellation');
    } else if (state == 'PAYMENT') {
        return t('payment');
    } else if (state == 'MANUAL_JOURNAL') {
        return t('Manual Journal');
    } 
    return "";
}
export default withStyles(styles)(withTranslation()(AllotmentDetailView));